export const USER_LIST_REQUEST = "USER_LIST_REQUEST";
export const USER_LIST_SUCCESS = "USER_LIST_SUCCESS";
export const USER_LIST_FAIL = "USER_LIST_FAIL";
export const USER_DETAILS_REQUEST = "USER_DETAILS_REQUEST";
export const USER_DETAILS_SUCCESS = "USER_DETAILS_SUCCESS";
export const USER_DETAILS_FAIL = "USER_DETAILS_FAIL";
export const ANALYTICS_REQUEST = "ANALYTICS_REQUEST";
export const ANALYTICS_SUCCESS = "ANALYTICS_SUCCESS";
export const ANALYTICS_FAIL = "ANALYTICS_FAIL";
export const ACTIVITY_SUCCESS = "ACTIVITY_SUCCESS";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNIN_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNIN_REQUEST = "SIGNIN_REQUEST";
export const SIGNIN_FAIL = "SIGNIN_FAIL";
